<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <div>
        <text class="title me-1">{{$route.meta.title}}</text>
      </div>
      <el-button v-if="isSupperAdmin" type="primary"  class="ms-2 me-3" @click="handleAdd" >添加分组</el-button>
    </div>
    <div class="pub-center pt-2" >
      <div class="search--box">
        <el-form-item label="年份：" class="me-1">
          <!--          <el-input v-model="params.year" style="width: 100px"/>-->
          <el-select v-model="params.year" style="width: 100px" clearable>
            <el-option v-for="i of YEARS" :key="i.ID" :value="i.ID" :label="i.Name" />
          </el-select>
        </el-form-item>
        <el-form-item label=""  >
          <el-input v-model="params.name" placeholder="请输入关键词" class="ms-1 me-1"/>
        </el-form-item>
        <el-button type="primary"  @click="getList(true)">搜索</el-button>
        <el-button type=""  @click="reset">重置</el-button>
      </div>

      <el-table scrollbar-always-on border   :data="list" style="width: calc(100% - 30px);height:calc(100% - 60px);position: absolute;left: 15px;top:50px;padding-bottom: 30px"  v-loading="loading">
        <el-table-column label="年份"  min-width="80px"  show-overflow-tooltip >
          <template #default="scope">
            {{scope.row.Year|| '-'}}
          </template>
        </el-table-column>
        <el-table-column label="阶段"  min-width="100px"  show-overflow-tooltip >
          <template #default="scope">
            {{scope.row.Stage==1?'初赛':'复赛'}}
          </template>
        </el-table-column>
        <el-table-column label="参赛组别" min-width="120px"  show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.LevelName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="参赛组名" min-width="250px"  show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Name || '-'}}
          </template>
        </el-table-column>

        <el-table-column label="大赛区域名称" min-width="200px"  show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.ZoneName || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="170px"  show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.CreatedTime || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="操作" :width="isSupperAdmin?'300px':'150px'">
          <template #default="scope">
            <el-button  size="small" type="primary" @click="handleSeespe(scope.$index, scope.row)">专家</el-button>
            <el-button  size="small" type="primary" @click="handleSeeWork(scope.$index, scope.row)">作品</el-button>
            <el-button  size="small" v-if="isSupperAdmin"  @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button  size="small" v-if="isSupperAdmin"     type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pub-footer d-flex align-items-center justify-content-center">
      <el-pagination  v-show="total>0" background
                      layout="total, sizes, prev, pager, next"
                      :page-sizes="[10, 20, 30, 40]"
                      :total="total"
                      v-model:current-page="params.current"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"/>
    </div>
    <!--    添加或修改分组-->
    <AddGroupCom :stage="stage" :item="choisedItem" @close="closeInfoChange" v-if="dialogVisible" @success="updateInfoChange"></AddGroupCom>
    <!--    添加专家-->
    <AddSpecialToGroup :item="choisedItem" @close="closeInfoChange" v-if="AddSpecdialogVisible" @success="closeInfoChange"></AddSpecialToGroup>
<!--    作品管理-->
    <AddWorkToGroup :item="choisedItem" :stage="stage" @close="closeInfoChange" v-if="AddWorkToGroupVisible" @success="closeInfoChange"></AddWorkToGroup>
  </div>
</template>

<script setup>
import AddSpecialToGroup from "@/components/AddSpecialToGroup"
import AddGroupCom from "@/components/AddGroupCom"
import AddWorkToGroup from "@/components/AddWorkToGroup"
import {computed, onMounted, reactive, ref} from "vue";
import {ElMessage, ElMessageBox} from "element-plus";
const LEVELS = [
  {ID:1,Name:"专科组"},
  {ID:2,Name:"本科生组"},
  {ID:3,Name:"研究生组"},
  {ID:4,Name:"所有分组"},
]
import {formatTime} from "@/utils/dateFun";
import {getYears,getName} from "@/utils/commonSetting"
import {needInitQueryFun} from "@/utils/common";
import {getWorkgroups, removeWorkgroup} from "@/api/workgroupAdmin";
import {useStore} from "vuex";
const store = useStore()
const isSupperAdmin =  computed(()=>store.state.loginModel.isSupperAdmin)
const YEARS = getYears()
const params = reactive({
  pageSize:10,
  current:1,
  name:null, // 关键词
  year:"", // 年份new Date().getFullYear()
})
const dialogVisible = ref(false)
const AddSpecdialogVisible= ref(false)
const AddWorkToGroupVisible = ref(false)
const choisedItem = ref()
const stage = 1; // 阶段（1 初赛，2 复赛）
const total = ref(0)
const list = ref([])
const loading = ref(false)

onMounted(()=>{
  getList()
})

const reset = ()=>{
  params.current = 1
  params.name = ""
  params.year = ""
  getList(true)
}
// 关闭信息修改
const closeInfoChange = ()=>{
  dialogVisible.value = false
  AddSpecdialogVisible.value = false
  AddWorkToGroupVisible.value = false
}
// 新建或修改成功
const updateInfoChange = ()=>{
  dialogVisible.value = false
  reset()
}

// 列表
const getList = async (init)=>{
  if(init){
    params.current = 1
  }
  loading.value = true
  const res = await getWorkgroups({...params,stage})
  loading.value = false
  if(res.err_code===0){
    total.value = res.total
    let data = res.data || []
    data.forEach(item=>{
      //  创建时间
      if(item.CreatedAt){
        item.CreatedTime = formatTime(item.CreatedAt)
      }
      if(item.Zone && item.Zone.Name){
        item.ZoneName = item.Zone.Name
      }
      if(item.Level){
        item.LevelName = getName(LEVELS,item.Level)
      }
    })
    list.value = data
  }else{
    return  ElMessage.warning("获取列表失败")
  }
}
// 页码改变
const handleSizeChange = (event) => {
  if(params.pageSize !==event){
    params.current = 1
    params.pageSize = event
    getList()
  }
}
const handleCurrentChange = ()=>{
  getList()
}
// 添加
const handleAdd = ()=>{
  choisedItem.value = {}
  dialogVisible.value = true
}
// 编辑
const handleEdit = (index,item)=>{
  choisedItem.value = item
  dialogVisible.value = true
}
// 删除
const handleDelete = (number,item)=>{
  ElMessageBox.alert('确定要删除吗？', '删除', {
    confirmButtonText: '确定',
    callback: (action) => {
      if(action==='confirm'){ // 确定
        const needInitQuery = needInitQueryFun(total.value,params.pageSize,number)
        removeWorkgroup({ids:[item.ID]}).then(res=>{
          if(res.err_code === 0){
            ElMessage.success(`删除成功`)
            if(needInitQuery){
              getList(true) // 重新请求
            }else{
              getList() // 重新请求
            }
          }else{
            ElMessage.error(res.err_msg ||`删除失败,请稍后再试`)
          }
        })
      }
    },
  })
}
// 查看专家
const handleSeespe = (index,item)=>{
  choisedItem.value = item
  AddSpecdialogVisible.value = true
  // ElMessage.warning(`功能暂未开放`)
}
// 查看作品
const handleSeeWork = (index,item)=>{
  choisedItem.value = item
  AddWorkToGroupVisible.value = true
}
</script>

<style scoped lang="scss">
.search--box{
  width: 100%;
  height: 60px;
  overflow-x: scroll;
  display: flex;

}
.search--box{
  ::v-deep .el-form-item__label{
    padding: 0 !important;
  }
}
//::v-deep .search--box .el-form-item__label{
//  padding: 0 5px 0 0 !important;
//}
///deep/  .search--box .el-form-item__label{
//  padding: 0 5px 0 0 !important;
//}
.link{
  background: transparent;
  border-color: transparent;
  color: #3f9dfd;
  height: auto;
  padding: 2px;
}
.link:hover{
  color: rgba(63,157,253,0.7);
}

</style>

